function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import AllSetPage from "../client-flow/clientOb/AllSetStep/AllSetPage";
import NoPermissionsRelationshipApproved from "../client-flow/clientOb/AllSetStep/noPermissionsRelationshipApproved";
import ClientOnboarding from "../client-flow/clientOb/ClientOnboarding";
import RelationshipApprovedWithAnimations from "../client-flow/clientOb/RelationshipSignedStep/RelationshipApprovedWithAnimations";
import AgreementStudioPage from "../components/AgreementStudioPage/AgreementStudioPage";
import AgreementStudioTemplates from "../components/AgreementStudioPage/AgreementStudioTemplateMode/AgreementStudioTemplates";
import CanceledProposalPage from "../components/CanceledProposalPage/CanceledProposalPage";
import ExpiredProposalPage from "../components/ExpiredProposalPage/ExpiredProposalPage";
import { withBlockPartiallyOnboardedVendor } from "../components/withBlockPartiallyOnboardedVendor/withBlockPartiallyOnboardedVendor";
import { routes } from "../constants";
import { withEnableIntercom } from "../intercom/withEnableIntercom";
import AdditionalPaymentProcessorInfoPage from "../pages/AdditionalPaymentProcessorInfoPage/AdditionalPaymentProcessorInfoPage";
import AgreementMinisite from "../pages/AgreementMinisite/AgreementMinisite";
import HomePage from "../pages/HomePage/HomePage";
import NoAccessPage from "../pages/NoAccessPage/NoAccessPage";
import Notification from "../pages/Notification/Notification";
import { NotificationActionPage } from "../pages/NotificationAction";
import ProposalTemplateLoader from "../pages/ProposalTemplates/ProposalTemplateLoader";
import { RedirectPage } from "../pages/RedirectPage";
import { ResetPasswordScreen, SetPasswordScreen, SignupScreen } from "../pages/unAuthorizedPages";
import { withOptimizedMobileViewport } from "../providers/MobileViewportWidthProvider";
export const unauthorizedPages = [{
  url: routes.signUp,
  component: SignupScreen,
  enableIntercom: true
}, {
  url: routes.setPassword,
  component: SetPasswordScreen,
  enableIntercom: true
}, {
  url: routes.resetPassword,
  component: ResetPasswordScreen,
  enableIntercom: true
}, {
  url: routes.notification(),
  component: Notification,
  enableIntercom: true
}, {
  url: routes.noPermissionsRelationshipAlreadyApproved,
  component: NoPermissionsRelationshipApproved,
  enableIntercom: false
}, {
  url: routes.allSignaturesAcquired,
  component: RelationshipApprovedWithAnimations,
  enableIntercom: false
}, {
  url: routes.expiredProposalPage,
  component: ExpiredProposalPage,
  supportsMobile: true,
  enableIntercom: false
}, {
  url: routes.canceledProposalPage,
  component: CanceledProposalPage,
  supportsMobile: true,
  enableIntercom: false
}, {
  url: routes.additionalPaymentProcessorInfo,
  component: AdditionalPaymentProcessorInfoPage,
  enableIntercom: true
}, {
  url: routes.notificationAction,
  component: NotificationActionPage,
  supportMobile: true,
  enableIntercom: true
}, {
  url: routes.noAccessPage,
  component: NoAccessPage,
  supportsMobile: true,
  enableIntercom: true
}].map(config => _objectSpread(_objectSpread({}, config), {}, {
  component: withOptimizedMobileViewport(withEnableIntercom(config.component, config.enableIntercom))
}));
export const getAuthorizedPages = _ref => {
  let {
    MOBILE_RESPONSIVENESS,
    AGREEMENT_STUDIO_MOBILE
  } = _ref;
  return [{
    url: routes.redirect,
    component: RedirectPage,
    supportsMobile: true,
    allowPartiallyOnboardedVendor: true,
    enableIntercom: true
  }, {
    url: routes.home,
    component: HomePage,
    allowPartiallyOnboardedVendor: true,
    enableIntercom: true,
    supportsMobile: MOBILE_RESPONSIVENESS
  }, {
    url: routes.agreementStudio,
    component: AgreementStudioPage,
    vendorOnly: true,
    enableIntercom: true,
    supportsMobile: AGREEMENT_STUDIO_MOBILE
  }, {
    url: routes.proposalTemplateStudio,
    component: AgreementStudioTemplates,
    enableIntercom: true
  }, {
    url: routes.minisite(),
    component: AgreementMinisite,
    enableIntercom: true
  }, {
    url: routes.draft(),
    component: AgreementStudioPage,
    vendorOnly: true,
    enableIntercom: true,
    supportsMobile: AGREEMENT_STUDIO_MOBILE
  }, {
    url: routes.proposalTemplate(),
    component: ProposalTemplateLoader,
    enableIntercom: true
  }, {
    url: routes.clientOnboarding(),
    component: ClientOnboarding,
    supportsMobile: true,
    enableIntercom: false
  }, {
    url: routes.allSet(),
    component: AllSetPage,
    supportsMobile: true,
    enableIntercom: false
  }].map(config => {
    if (config.supportsMobile) {
      config.component = withOptimizedMobileViewport(config.component);
    }
    if (!config.allowPartiallyOnboardedVendor) {
      config.component = withBlockPartiallyOnboardedVendor(config.component);
    }
    config.component = withEnableIntercom(config.component, config.enableIntercom);
    return config;
  });
};